import useGetRecommendedVehicles from '~/hooks/home/services/useGetRecommendedVehicles';
import useGetMostViewedOrMostRecentYMM from './useGetMostViewedOrMostRecentYMM';

const emptyObject = {};

export default function useGetBecauseYouViewed() {
  const targetVehicle = useGetMostViewedOrMostRecentYMM();

  const vehicleId = targetVehicle?.vehicleId;

  const { vehicles, isLoaded } = useGetRecommendedVehicles(
    12,
    emptyObject,
    vehicleId
  );

  return { vehicles, isLoaded };
}
